export const API_URLS = {
    LOGIN: "/api/auth/log-in",
    BROKER_ADMIN: "/api/v1/broker-admin",
    SURVEY: "/api/v1/survey",
    BROKER_GROUP: "/api/v1/broker-group",
    FORM: "/api/v1/form",
    BROKER: "/api/v1/broker",
    CLIENT: "/api/v1/client",
    CONDUCT: "/api/v1/conduct",
    FILE_UPLOADER: "/api/v1/file-uploader",
    FORM_GROUP: "/api/v1/form-group"
}